import { Link } from 'gatsby';

import React from 'react';

import cn from 'classnames';

import paginatedUrl from '../../utils/paginated-url';

import { ReactComponent as ArrowSVG } from './arrow.svg';

import styles from './styles.module.css';

export interface IPageInfo {
  basePath: string;
  hasNext: boolean;
  hasPrevious: boolean;
  currentPage: number;
}

export interface IPaginatorProps {
  pageInfo: IPageInfo;
}

// Enables a smooth scroll behavior between pages.
// Doesn't smooth scroll into posts because the paginator isn't mounted in both :)
const smoothScrollTag = (
  <style
    dangerouslySetInnerHTML={{
      __html: `html { scroll-behavior: smooth; }`
    }}
  />
);

// Turn the arrow around
const reverse = {
  transform: 'rotate(180deg)'
};

export default function Paginator({
  pageInfo: { hasNext, hasPrevious, currentPage, basePath }
}: IPaginatorProps) {
  if (!hasPrevious && !hasNext) {
    return null;
  }

  return (
    <div className={styles.paginator}>
      {smoothScrollTag}
      {hasPrevious && (
        <Link
          className={cn(styles.link, styles.linkPrevious)}
          to={paginatedUrl(basePath, currentPage - 1)}
        >
          <ArrowSVG style={reverse} />
          <span>Newer posts</span>
        </Link>
      )}
      {hasNext && (
        <Link
          className={cn(styles.link, styles.linkNext)}
          to={paginatedUrl(basePath, currentPage + 1)}
        >
          <span>Older posts</span>
          <ArrowSVG />
        </Link>
      )}
    </div>
  );
}
